/**
 * ContactPerson
 */
interface ContactPerson {
    id?: string;
    worktype: ContactWorkType; // 업무 타입
    workname: string;
    name: string;
    email: string;
    createdAt: Date;
    updatedAt: Date;
}

export enum ContactWorkType {
    Inquiry = 'inquiry',
    Report = 'report',
}

export namespace ContactWorkType {
    export function from(value: string): ContactWorkType {
        switch (value) {
        case 'inquiry':
            return ContactWorkType.Inquiry;
        case 'report':
            return ContactWorkType.Report;
        default:
            throw new Error(`Unknown worktype value: ${value}`);
        }
    }
}

export default ContactPerson;